module.exports = __webpack_public_path__ + "media/01 the Spring Festival.dc34ebd1.mp3";